import React, { useEffect } from 'react';
import { toVideoSource, toVideoNewTabUrl } from '../constants/videoGuide';

// Video popup: plays right away. "Open in new tab" and "Close" sit at the top right,
// above the video. Click outside / Esc closes it.
const btn = (primary) => ({
  display: 'inline-flex', alignItems: 'center', gap: 6, height: 32, padding: '0 14px',
  borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap',
  border: primary ? '1px solid #00A19D' : '1px solid rgba(255,255,255,0.35)',
  background: primary ? '#00A19D' : 'rgba(255,255,255,0.12)', color: '#fff',
});

export default function VideoGuideModal({ open, url, onClose }) {
  const source = toVideoSource(url);
  const newTabUrl = toVideoNewTabUrl(url);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [open, onClose]);

  if (!open) return null;

  const openNewTab = () => {
    if (newTabUrl) window.open(newTabUrl, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <div
      data-overlay="video-guide"
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 20500, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
    >
        <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 960 }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginBottom: 8 }}>
            {newTabUrl && (
              <button type="button" onClick={openNewTab} style={btn(false)}>Open in new tab ↗</button>
            )}
            <button type="button" onClick={onClose} style={btn(true)}>Close ✕</button>
          </div>
          <div style={{ width: '100%', aspectRatio: '16 / 9', background: '#000', borderRadius: 10, overflow: 'hidden', boxShadow: '0 25px 60px rgba(0,0,0,0.5)' }}>
            {source && source.type === 'iframe' && (
              <iframe
                title="Video Guide"
                src={source.src}
                style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            )}
            {!source && (
              <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 14 }}>Video coming soon</div>
            )}
            {source && source.type === 'video' && (
              <video src={source.src} controls autoPlay style={{ width: '100%', height: '100%', display: 'block' }} />
            )}
          </div>
        </div>
    </div>
  );
}
